import { ComponentIds, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { handleSectionViewerObjectOnRedo, isBoaxelSectionRedo, } from "../functions/interactiveBoaxelSection";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { viewerObjectRedo, viewerObjectUndo, } from "../utils/viewerObjectHandler";
export default class HandleInteractiveBoaxelUndoRedoSystem extends SystemBase {
    constructor(core) {
        super(ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
        this.core = core;
        this.systemsAfterMe = null;
        this.systemsBeforeMe = null;
        this.mandatoryComponents = [COMPONENT_IDS.NON_WORLDLY_ITEM_COMPONENT];
        this.doingChangesOnComponent = [];
        this.id = "HandleInteractiveBoaxelUndoRedoSystem";
    }
    /**
     * Core doesn't handle ViewerObjects on undo/redo
     * Here the viewerObject will be removed on undo and re-added on redo
     * @param _entity
     * @param _newComponent
     * @returns
     */
    onAddComponent(_entity, _newComponent) {
        const isUndoAction = !_newComponent.entity && !!_newComponent.entityStateBeforeLoadingSnapshot;
        const isRedoAction = !!_newComponent.entity && !_newComponent.entityStateBeforeLoadingSnapshot;
        if (isUndoAction)
            viewerObjectUndo(_entity);
        else if (isRedoAction) {
            if (isBoaxelSectionRedo(_newComponent.entity)) {
                handleSectionViewerObjectOnRedo(_entity, this.core);
            }
            else
                viewerObjectRedo(_entity, this.core);
        }
    }
}
